export default `
  @font-face {
    font-family: 'GilroyAlt';
    src:  url('/fonts/GilroyAlt-Medium.woff2?v=1') format('woff2'),
          url('/fonts/GilroyAlt-Medium.woff?v=1') format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'GilroyAlt';
    src:  url('/fonts/GilroyAlt-SemiBold.woff2?v=1') format('woff2'),
          url('/fonts/GilroyAlt-SemiBold.woff?v=1') format('woff');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'GilroyAlt';
    src:  url('/fonts/GilroyAlt-Bold.woff2?v=1') format('woff2'),
          url('/fonts/GilroyAlt-Bold.woff?v=1') format('woff');
    font-weight: 600;
    font-style: normal;
  }
  html {
    overflow-x: hidden;
  }
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  input, button, textfield,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    font-family: 'GilroyAlt', sans-serif;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    text-rendering:optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1.3;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  @media only screen and (max-width: 600px) {
    html, body {
      overflow-x: hidden;
      width: 100%;
    }
  }
`;
